<template>
  <router-view></router-view>
  <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/katex@0.11.1/dist/katex.min.css" />
</template>

<script>


export default {
  name: 'App',
  components:{
  }
}
</script>

<style>

*{
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
}

.primary-button{
  background-color: #6467f0;
  color: white;
  padding: 6px 25px;
  border-radius: 8px;
  width: max-content;
  box-sizing: border-box;
}

.logo{
  width:40px;
  height:40px;
  border-radius: 50%;
  border: 1px solid #E4E7ED;
}

.back{
  width: 100%;
  height: 100vh;
  background-color: white;
  box-sizing: border-box;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
}

.row{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}



.row-end{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}
.row-start{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.row-between{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

.row-evenly{
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: center;
}

.plain-button{
  background-color:white;
  color:gray;
  font-weight: normal;
  padding: 5px 15px;
  border-radius: 20px;
  border: 1px solid #EBEEF5
}

.plain-button:hover{
  background-color:#6467F0;
  color:white;
  border: 1px solid #6467F0;
  padding: 5px 15px;
  border-radius: 20px
}

.info-box{
  padding:10px 5px;
  background-color: white;
  border-radius: 0px;
  width: 150px;
  font-size: 14px;
  margin-top: 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.query-box{
  width: 100%;
  padding:10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  border-radius: 25px;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1);
  background-color: white;
}


.info-box:hover{
  background-color: whitesmoke;
  color: #6467f0;
  border-radius: 0px;
  border: 1px solid lightgray;
}

.sub-logo{
  border-radius:12px;
  padding:10px;
  font-size:22px;
  font-weight: bold;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  margin-top:20px;
  box-sizing: border-box;
  width: 100%;
  border: 2px solid white;
}

.sub-logo:hover{
  border: 2px solid #6467f0;
  color: #6467f0;
}

.op{
  font-size: 14px;
  color:white;
  width: 150px;
  background-color: #6467f0;
  font-weight: normal;
  border-radius: 8px;
  padding: 5px 10px;
  margin-top: 15px;
}

.left-bar{
  height:100%;
  padding-left: 15px;
  padding-right:15px;
  display: flex;
  background-color: ghostwhite;
  box-sizing: border-box;
  width: max-content;
  flex-direction: column;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.1);
}

.input-plain{
  border-radius: 8px;
  outline: none;
  border: 1px solid lightgray;
  height:40px;
  margin-top: 20px;
  text-indent: 15px;
}

.input-plain:hover{
  border: 1px solid #6467f0;
}

</style>
